import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { LeftNavigationComponent } from './left-navigation/left-navigation.component';
import { AgGridCustomizedCellComponent } from './ag-grid-customized-cell/ag-grid-customized-cell.component';
import { MaterialModule } from './modules/material.module';
import { DocumentModalComponent } from './document-modal/document-modal.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SupportedDocumentModalComponent } from './supported-document-modal/supported-document-modal.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';




@NgModule({
  declarations: [
    // HeaderComponent,
    // LeftNavigationComponent,
    AgGridCustomizedCellComponent,
    DocumentModalComponent,
    SupportedDocumentModalComponent,
    ConfirmationDialogComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    CommonModule,
    FormsModule,
    MatTooltipModule,
    MatButtonModule,
    MatCheckboxModule
  ],
  exports :[
    DocumentModalComponent
    // HeaderComponent,
    // LeftNavigationComponent
  ]
})
export class SharedModule { }
